import cookieCommons from 'common/cookieCommons';
import { IFolderInfo } from '../../interfaces/training.interface';
import { tmsHTTPRequest } from '../../services/axios/httpRequest';

export const getAccessibleUsers = () => {
  return tmsHTTPRequest.get('/');
};

export const updateFolder = (
  data: IFolderInfo,
  fid: string | string[] | undefined
) => {
  return tmsHTTPRequest.put(`/v1/folders/edit/${fid}`, {
    ...data,
    userId: cookieCommons.getTmsUserId(),
  });
};

export const renameFile = (data: IFolderInfo, id: string) => {
  return tmsHTTPRequest.put(`/v1/files/rename/${id}`, data);
};

export const getFolderInfo = (fid: string | string[] | undefined) => {
  return tmsHTTPRequest.get(`/v1/folders/details/${fid}`);
};
